import styled from 'styled-components'

const ModalStyle = styled.div`
  .ant-btn {
    height: auto;
    padding-top: 6px;
    padding-bottom: 6px;
    white-space: pre-wrap;
    &.close {
      position: absolute;
      top: 24px;
      right: 24px;
      color: #595959;
      z-index: 1;
    }
    &.ant-btn-link {
      text-align: left;
    }
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .ml-1 {
    margin-left: 1rem
  }
  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
  .divider {
    margin: 24px -24px;
    border: 1px solid #E5E5E5;
  }
  .group-name {
    .ant-form-item-label {
      font-family: Montserrat;
      font-style: normal;
      font-weight: bold;
      line-height: 14px;
      text-transform: uppercase;  
    }
    .ant-form-item-label > label {
      color: #8493AA;
    }
  }
  .ant-form .group-name label {
    font-size: 11px;
  }
  .form-crud {
    .ant-form-item-label {
      text-align: left;
      padding-left: 15px;
    }
  }
  .ant-form-explain {
    background: #FFD9D9;
    display: inline-block;
    padding: 5px 10px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    text-transform: uppercase;
  }
  h3 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 14px;
    text-transform: uppercase;
    color: #8493AA;
    padding-left: 15px;
  }
  .ant-list-items {
    .ant-btn-link {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #6B6B6B;
      &:hover {
        background: #D9EBF9;
      }
    }
  }
  .controls-panel {
    max-height: 300px;
    overflow: hidden;
    margin-bottom: 24px;
    .max-height {
      max-height: 300px;
      overflow: auto;
    }
  }
  .form-change-all {
    .ant-form-item-label {
      text-align: left;
    }
  }
  .w-100 {
    width: 100%;
  }
  .permission-select {
    width: 100px;
  }
`

export default ModalStyle